import { useContext } from 'react'
import { useWindowSize } from 'react-use'
import { IconComponent } from 'ui'
import { CopilotContext } from '../context'
import { CopilotSidebarContext } from '../contexts/sidebar'
import ImportInput from './inputs/import'
import CreateInput from './inputs/create'
import PresetList from './presets'
import { Button, Header, Section, Sidebar } from './style'
import { CopilotApiContext } from '../contexts/api'
import { SIDEBAR_COLOR } from '../constants'

const CopilotSidebar = () => {
    const { disabled, presets: createdPresets, importedPresets } = useContext(CopilotContext)
    const { isSidebarOpen, closeSidebar, openSidebar } = useContext(CopilotSidebarContext)

    const { createdCursor, importedCursor, fetchUserPresets, fetchImportedPresets } = useContext(CopilotApiContext)

    const { width: windowWidth } = useWindowSize()
    const isTooSmallForButton = windowWidth < 1440

    if (disabled) {
        return null
    }

    return (
        <>
            {!isSidebarOpen && !isTooSmallForButton && (
                <Button
                    icon={<IconComponent icon="sidebar" height={18} width={18} />}
                    size="small"
                    onClick={openSidebar}
                >
                    Open Staff Mode
                </Button>
            )}
            <Sidebar open={isSidebarOpen} side="right" color={SIDEBAR_COLOR}>
                <Header title="Staff Mode" onClose={closeSidebar} />
                <Section defaultOpen icon="source" title="Import Presets">
                    <PresetList presets={importedPresets} cursor={importedCursor} fetchMore={fetchImportedPresets}>
                        <ImportInput />
                    </PresetList>
                </Section>
                <Section defaultOpen icon="flash" title="Manage Presets">
                    <PresetList presets={createdPresets} cursor={createdCursor} fetchMore={fetchUserPresets}>
                        <CreateInput />
                    </PresetList>
                </Section>
            </Sidebar>
        </>
    )
}

export default CopilotSidebar
